const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.VITE_BACKEND_URL ||
  window.location.origin;

export const FALLBACK_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="800" height="600">
      <rect width="100%" height="100%" fill="#F2EFEB"/>
      <text x="50%" y="48%" dominant-baseline="middle" text-anchor="middle"
        font-family="Arial" font-size="34" fill="#2C4A3B">
        Maharlika
      </text>
      <text x="50%" y="57%" dominant-baseline="middle" text-anchor="middle"
        font-family="Arial" font-size="18" fill="#5C6B64">
        Image Coming Soon
      </text>
    </svg>
  `);

export function resolveImage(url) {
  if (!url || typeof url !== "string") return FALLBACK_IMAGE;

  const clean = url.trim();
  if (!clean) return FALLBACK_IMAGE;

  if (clean.startsWith("data:")) return clean;
  if (clean.startsWith("http://") || clean.startsWith("https://")) return clean;

  if (clean.startsWith("/api/uploads/")) {
    return `${BACKEND_URL}${clean}`;
  }

  if (clean.startsWith("/uploads/")) {
    return `${BACKEND_URL}/api${clean}`;
  }

  if (clean.startsWith("uploads/")) {
    return `${BACKEND_URL}/api/${clean}`;
  }

  return clean;
}

export function imageStyle(url) {
  return { backgroundImage: `url(${resolveImage(url)})` };
}
